import React, { useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { getApiClient } from "../../server/get_api_client";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function TrainingPrograms({
  Title = "Fellowship",
  Active = true,
  value,
  onChange,
  type,
}) {
  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const screenWidth = useScreenWidth();

  useEffect(() => {
    getApiClient()
      .getTrainingProgram(type)
      .then((res) => {
        if (res.data) {
          const options = res.data.map((item) => ({
            key: item.accountid,
            value: item.accountid,
            text: item.name,
          }));
          setData(options);
        }
      })
      .catch((error) => console.error("API Error:", error));
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      const selectedOption = data.find((data) => data.value === value);
      if (selectedOption) {
        setName(selectedOption.text);
      } else {
        setName("");
      }
    } else {
      setName("");
    }
  }, [value, data]);

  // Called when dropdown selection changes
  const handleChange = (event, data) => {
    onChange(data.value);

    const selectedOption = data.options.find(
      (option) => option.value === data.value
    );
    if (selectedOption) {
      setName(selectedOption.text);
    }
  };

  return (
    <Container>
      <FieldName>{Title}</FieldName>
        <DropdownWrapper>
          <CustomDropDown
            placeholder="Select training program"
            fluid
            search
            selection
            disabled={!Active}
            onChange={handleChange}
            value={value}
            options={data}
          />
          <SearchIcon name="search" />
        </DropdownWrapper>
    </Container>
  );
}

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;


const FieldName = styled.div`
  text-align: right;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;

const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;

  height: 36px;
`;

const CustomDropDown = styled(Dropdown)`
  background: var(--editable) !important;
  border: none !important;

  .dropdown.icon {
    display: none !important;
  }
&.ui.selection.dropdown {
    min-height: 30px !important;
    border-radius: 20px !important;
    padding: 0 35px 0 10px !important; /* Match padding-left: 10px */
    line-height: 30px !important;
    
    color: #304961 !important;
    font-family: "Museo Sans Cyrl" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border: none !important;
    outline: none !important;
  }
  /* Style the create option */
  .menu > .item[data-value="create-new"] {
    background-color: #f8f9fa !important;
    border-top: 1px solid #e9ecef !important;
    color: #87a9bf !important;
    font-weight: 500 !important;
  }

  .menu > .item[data-value="create-new"]:hover {
    background-color: #87a9bf !important;
    color: white !important;
  }
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #304961 !important;
  pointer-events: none !important;
`;

const CustomContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

const CreateOptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #87a9bf;
  font-weight: 500;
`;

const CreateIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #87a9bf;
  color: white;
  font-size: 12px;
  font-weight: bold;
`;

// Import CustomTextField component
const CustomTextField = ({ Active, Title, value, onChange, placeholder }) => {
  return (
    <TextFieldWrapper>
      <StyledInput
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={!Active}
      />
    </TextFieldWrapper>
  );
};

const TextFieldWrapper = styled.div`
  flex: 1;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  background: var(--editable);
  
  &:focus {
    outline: none;
    border-color: #87a9bf;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export default TrainingPrograms;
